import shouldForwardProp from '@styled-system/should-forward-prop'
import React from 'react'
import styled from 'styled-components'
import { color, flexbox, grid, layout, space, typography } from 'styled-system'

export const fontSizes = {
  superHeading: 'min(12vh, min(15vw, 124px))',
  // huge: 'min(11vh, min(15vw, 116px))',
  // extraLarge: 'min(8.5vh, min(13vw, 86px))',
  heading: ['min(7vh, min(10.5vw, 80px))', 'min(8vh, min(12vw, 80px))'],

  quote: 'min(8vh, min(9vw, 64px))',
  // medium: 'min(5vh, min(9vw, 56px))',
  // mediumSmall: 'min(4.8vh, min(7.5vw, 42px))',
  copy: 'min(4vh, min(5vw, 28px))',
  // extraSmall: 'min(4vh, min(5vw, 28px))',
  // extraExtraSmall: 'min(3.8vh, min(4.8vw, 26px))',
  // tiny: 'min(3vh, min(4vw, 22px))',
  body: 'min(2.8vh, min(3.8vw, 20px))'
}

export const lineHeights = {
  h1: 1,
  h2: 1,
  h3: 1,
  h4: 1.2,
  p: 1.3
}

const headingSizes = {
  h1: fontSizes.superHeading,
  h2: fontSizes.heading,
  h3: fontSizes.heading,
  h4: fontSizes.copy,
  p: fontSizes.copy
}

export const Heading = ({
  as = 'h1',
  children,
  fontWeight = '700',
  color = 'var(--msk-color)',
  ref,
  ...props
}) => {
  return (
    <BaseHeading
      as={as}
      color={color}
      fontSize={headingSizes[as]}
      lineHeight={lineHeights[as]}
      textAlign="left"
      fontWeight={fontWeight}
      {...props}
      ref={ref}
    >
      {children}
    </BaseHeading>
  )
}

export const Paragraph = ({
  maxWidth = '60ch',
  fontWeight = '400',
  children,
  ref,
  ...props
}) => {
  return (
    <Text
      as="p"
      color="inherit"
      fontSize={headingSizes.p}
      lineHeight={lineHeights.p}
      textAlign="left"
      maxWidth={maxWidth || '26ch'}
      fontWeight={fontWeight}
      {...props}
      ref={ref}
    >
      {children}
    </Text>
  )
}

const BaseHeading = styled('h1')
  .attrs(props => ({
    zIndex: 5,
    marginBlockStart: 0,
    textDecoration: 'none',
    ...props
  }))
  .withConfig({
    shouldForwardProp
  })(
  {
    textWrap: 'balance'
  },
  typography,
  space,
  layout,
  color,
  flexbox,
  grid
)

export const Text = styled('span')
  .attrs(props => ({
    zIndex: 5,
    textWrap: 'balance',
    ...props
  }))
  .withConfig({
    shouldForwardProp
  })({}, typography, space, layout, flexbox, color, grid)

export const Eyebrow = ({ children, ...props }) => {
  return (
    <Heading
      as="h3"
      m={0}
      bg="white"
      style={{
        mixBlendMode: 'screen',
        fontWeight: '600'
      }}
      px={2}
      py={1}
      {...props}
    >
      {children}
    </Heading>
  )
}
